
fx.ns("shared.popups", class SharedPhotosPopup extends fx.components.Popup{
    
    constructor(model)
    {
        super();
        this.model = model;
        this._currentSharedPhotos = fx.service("PhotoSharingService").currentSharedPhotos;
        this.contentWidth = 380;
        this.contentHeight = 180;
    }

    create()
    {
        super.create();

        if(this._currentSharedPhotos)
        {
          this.guestid = this._currentSharedPhotos.guestid;
          let guestname = this._currentSharedPhotos.guestname;
          let photosnumber = this._currentSharedPhotos.photos.length;
  
          this.hbox_photos = new fx.components.HBox();
          this.hbox_photos.addChild(new fx.components.Text({text:fx.text("<b>$</b> vous a envoyé", guestname), className:"center shareInfoText"}), {height:30, left:0, width:"100%"});
          this.hbox_photos.addChild(new fx.components.Text({text:fx.text("$ photos", photosnumber), className:"bold center shareInfoText"}), {height:30, left:0, width:"100%"});

          // button   
          this.exitButton = new fx.components.Button({label : fx.text("Refuser"), className : "exitButton"});
          this.hbox_photos.addChild(this.exitButton, {top:60, height:60, width : 150, left: 0});

          // button   
          this.okButton = new fx.components.Button({label : fx.text("Voir les photos"), type : "filled"});
          this.hbox_photos.addChild(this.okButton, {top:60, height:60, width : 200, right: 0});
          
          this.addChild(this.hbox_photos, {top: 40, width: "90%", left: "center"});
        }
    }

    onReady()
    {
      this.on("click", this.onClick, this.okButton);
      this.on("click", this.onClose, this.exitButton);
    }

    onClose(){
      fx.service("PhotoSharingService").reject();
      this.close();
    }

    onClick(){
      this.close();
      this.model.event("shared-photos-panel");
    }
});